import PasswordExpiredModal from './PasswordExpiredModal';

export default PasswordExpiredModal;
